<template>
  <div class="text-14 md:text-16 xl:text-18 -mb-2.5 text-orange-700">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>
